import './index.css';
import React,{useState} from 'react';
import Shades from './Shades';
import Shadeinput from './Shadeinput';
import randomColor from 'randomcolor';
import { useEffect } from 'react';
function App() {

  const [color,setColor]=useState("#000");
  useEffect(()=>{
    setColor(randomColor);
  },[])
  const onInputChange=(value)=>{
    setColor(value);
  }
  return (
    <div className="App">
    <Shadeinput color={color} onInputChange={onInputChange}/>
    <Shades color={color}/>
    </div>
  );
}

export default App;
